<template>
  <div id="bidrule" class="zl-form-group rule-contaniner">
    <div class="zl-form-group-header">
      <div class="zl-form-group-title">
        <i class="title-decorate iconfont icon-decorate" />
        竞价规则
      </div>
    </div>
    <div class="zl-form-group-form">
      <el-row :gutter="24">
        <el-col :span="8">
          <el-form-item label="竞价范围" prop="biddingScope" label-width="100px">
            <el-radio-group v-if="!isDisplay" v-model="form.biddingScope">
              <el-radio label="1">公开</el-radio>
              <el-radio label="3">邀请竞价</el-radio>
            </el-radio-group>
            <span v-else class="mybidding-display">{{ biddingScope }}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <div v-show="+form.biddingScope===3 " class="show-company-list">
        <div class="title">邀请指定供应商参与竞价</div>
        <div class="company-list">
          <div v-for="(item, index) in form.inviteSupplierList" :key="item.id" class="company-list-item">
            <p class="lable">{{ item.supOfficeName }}</p>
            <p>联系人：{{ item.contactName }}</p>
            <p>联系电话：{{ item.contactPhone }}</p>
            <p>邮箱：{{ item.contactEmail }}</p>
            <div v-if="!isDisplay" class="btn-remove">
              <el-button type="text" @click="delBtn(index)">删除</el-button>
            </div>
          </div>
          <div v-if="!isDisplay" class="company-upload">
            <img
              class="company-upload-img"
              :src="addImage"
              @click="dialogVisible = true"
            >
          </div>
        </div>
      </div>
      <el-row :gutter="24">
        <el-col :span="24">
          <el-form-item label="竞价模式" prop="biddingMode" label-width="100px">
            <el-radio-group v-if="!isDisplay" v-model="form.biddingMode">
              <el-radio label="1">竞买</el-radio>
              <el-radio label="2">竞卖</el-radio>
            </el-radio-group>
            <span v-else class="mybidding-display">{{ biddingMode }}</span>
          </el-form-item>
          <div v-if="!isDisplay" class="show-tips">竞买：价格逐渐降低；竞卖：价格逐渐升高）</div>
        </el-col>
      </el-row>
      <el-row v-if="+form.biddingScope!==3" :gutter="24">
        <el-col :span="8">
          <el-form-item label="报名截止时间" prop="signUpDeadline" label-width="100px">
            <el-date-picker
              v-if="!isDisplay"
              v-model="form.signUpDeadline"
              type="datetime"
              placeholder="选择日期时间"
              value-format="yyyy-MM-dd HH:mm:ss"
            />
            <span v-else class="mybidding-display"> {{ form.signUpDeadline }} </span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="8">
          <el-form-item label="竞价开始时间" prop="startTime" label-width="100px">
            <el-date-picker
              v-if="!isDisplay"
              v-model="form.startTime"
              type="datetime"
              placeholder="选择日期时间"
              value-format="yyyy-MM-dd HH:mm:ss"
              @change="dataChange"
            />
            <span v-else class="mybidding-display"> {{ form.startTime }} </span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="24" style="display:flex;">
          <el-form-item prop="biddingRounds" label="正式竞价轮次" label-width="100px">
            <!-- <el-input-number v-if="!isDisplay" v-model="form.biddingRounds" style="width:150px" :min="1" :max="5" label="" @change="roundChange" /> -->
            <InputNumber v-if="!isDisplay" v-model="form.biddingRounds" :readonly="true" style="width:150px" :min="1" :max="5" @change="roundChange" />
            <span v-else class="mybidding-display"> {{ form.biddingRounds }} </span>
          </el-form-item>
          <el-form-item label="轮次时长" label-width="70px">
            <el-input v-if="!isDisplay" v-model="form.roundLength" style="width:120px" maxlength="100" placeholder="请输入内容" @change="roundLengthChange" />
            <span v-else class="mybidding-display"> {{ form.roundLength }} </span>
            分钟
          </el-form-item>
          <el-form-item label="间隔时长" label-width="70px">
            <el-input v-if="!isDisplay" v-model="form.intervalLength" style="width:120px" maxlength="100" placeholder="请输入内容" @change="revesionChange" />
            <span v-else class="mybidding-display"> {{ form.intervalLength }} </span>
            分钟
          </el-form-item>
        </el-col>
      </el-row>
      <div v-for="(item, index) in form.roundsList" :key="`${item.keys}-${index}`" class="show-round-list" :gutter="24">
        <div class="show-round-list-item">
          <span class="lable requireds"> 第{{ index+1 }}次竞价时间</span>
          <el-date-picker
            v-if="!isDisplay"
            v-model="item.biddingStartTime"
            style="width:200px!important;"
            type="datetime"
            :disabled="index === 0"
            placeholder="选择日期时间"
            value-format="yyyy-MM-dd HH:mm:ss"
          />
          <span v-else class="mybidding-display"> {{ item.biddingStartTime }} </span>
          <span style="margin-left:15px">~</span>
          <el-date-picker
            v-if="!isDisplay"
            v-model="item.biddingEndTime"
            style="width:200px!important;margin-left:15px"
            type="datetime"
            placeholder="选择日期时间"
            value-format="yyyy-MM-dd HH:mm:ss"
          />
          <span v-else class="mybidding-display"> {{ item.biddingEndTime }} </span>
          <el-checkbox v-if="!isDisplay" v-model="item.hidePriceSign" true-label="Y" false-label="N" :disabled="form.roundsList.length-1 === index" style="margin-left:30px">暗价</el-checkbox>
          <span v-else class="mybidding-display"> {{ item.hidePriceSign ==='Y'? '暗价':'明价' }} </span>
        </div>
      </div>
      <!--上传文件 -->
      <div class="round-upload">
        <p v-if="!isDisplay">上传竞价文件</p>
        <UploadSelect
          v-model="form.fileList"
          :url="url"
          :limit="0"
          :base-u-r-l="baseURL"
          :get-data="() => ({ fileType: 'bidding' })"
          name="files"
          :on-success="onSuccess"
          :before-remove="beforeRemove"
          :click-file="clickFile"
          :submit="submit"
          :disabled="isDisplay"
        />
      </div>
    </div>
    <!-- 选择供应商 -->
    <el-dialog
      title="选择供应商"
      :visible.sync="dialogVisible"
      width="70%"
      @close="handleClose"
    >
      <el-row style="margin-bottom: 10px">
        <el-col :span="8">
          <el-input v-model="keys" :placeholder="$t('bidmanagementpur.mybidding.bindRuleSearchPlaceholder')" @keyup.enter.native="search"> <i slot="suffix" class="common-hand el-input__icon iconfont  icon-sousuo" @click="search" /> </el-input>
        </el-col>
      </el-row>
      <div>
        <el-table v-loading="ruleSearchLoading" max-height="600px" :default-sort="{prop: 'phone', order: 'ascending'}" :data="supperShowList" stripe style="width: 100%" :header-cell-style="{ background: '#e9f3fe', color: '#666666', fontSize: '12px', fontWeight: 'bold' }" class="table" @sort-change="sortChange" @selection-change="handleSelectionChange">
          <el-table-column
            type="selection"
            width="55"
          />
          <el-table-column type="index" width="50" label="#" />
          <el-table-column prop="name" label="供应商名称" sortable="name" />
          <el-table-column prop="master" label="联系人" sortable="master" />
          <el-table-column prop="phone" label="联系电话" sortable="phone" />
          <el-table-column prop="email" label="邮箱" sortable="email" />
        </el-table>
        <el-pagination
          class="rigth"
          :page-sizes="[20, 30, 50, 100]"
          :page-size="querInfo.pagesize"
          :total="total"
          layout="->,total, prev, pager, next, sizes"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addSupper">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>
<script>
import { beforeRemove, submit, clickFile } from '../config/fn'
import UploadSelect from './upload-select.vue'
import addImage from '@/assets/images/add-company.png'
import http from '@/plugin/axios'
import InputNumber from './InputNumber.vue'
export default {
  components: {
    UploadSelect,
    InputNumber
  },
  props: {
    form: {
      type: Object,
      default: () => []
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    isDisplay: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      beforeRemove: beforeRemove,
      submit: submit,
      clickFile: clickFile,
      baseURL: process.env.VUE_APP_BASE_API,
      url: '/srmFile/uploadFiles',
      addImage: addImage,
      dialogVisible: false,
      supperShowList: [],
      querInfo: {
        pagenum: 1,
        pagesize: 20
      },
      total: null,
      multipleSelection: [],
      keys: '',
      ruleSearchLoading: false,
      currentSort: {}
    }
  },
  computed: {
    biddingScope() {
      let des = ''
      switch (this.form.biddingScope) {
        case '1':
          des = '公开'
          break
        case '2':
          des = '本单位公开'
          break
        case '3':
          des = '邀请竞价'
          break
      }
      return des
    },
    biddingMode() {
      let des = ''
      switch (this.form.biddingMode) {
        case '1':
          des = '竞买'
          break
        case '2':
          des = '竞卖'
          break
      }
      return des
    }
  },
  created() {
    // 处理默认值
    if (this.isDisplay) {
      return
    }
    this.search()
  },
  methods: {
    handleClose() {
      console.log('关闭')
      this.ruleSearchLoading = false
    },
    onSuccess(_this, data) {
      const file = data.data || []
      _this.fileList.push(...file)
      _this.$emit('input', _this.fileList)
    },
    // 数字前置补零
    digit(num, length) {
      let str = ''
      num = String(num)
      length = length || 2
      for (let i = num.length; i < length; i++) {
        str += '0'
      }
      return num < Math.pow(10, length) ? str + (num | 0) : num
    },
    // 转化日期格式
    toDateString(d, format) {
      if (d === null || d === '') {
        return ''
      }
      const date = new Date(d || new Date())
      const ymd = [
        this.digit(date.getFullYear(), 4), this.digit(date.getMonth() + 1), this.digit(date.getDate())
      ]
      const hms = [
        this.digit(date.getHours()), this.digit(date.getMinutes()), this.digit(date.getSeconds())
      ]
      format = format || 'yyyy-MM-dd HH:mm:ss'
      return format.replace(/yyyy/g, ymd[0])
        .replace(/MM/g, ymd[1])
        .replace(/dd/g, ymd[2])
        .replace(/HH/g, hms[0])
        .replace(/mm/g, hms[1])
        .replace(/ss/g, hms[2])
    },
    dataChange(val) {
      if (!val) { return }
      this.dataDeal()
    },
    dataDeal() {
      if (!this.form.startTime) { return }
      const roundsList = this.form.roundsList || []
      const startTime = new Date(this.form.startTime).getTime()
      roundsList.forEach((item, index) => {
        if (index === 0) {
          item.biddingStartTime = this.form.startTime
          item.biddingEndTime = this.toDateString(startTime + (this.form.roundLength * 60 * 1000))
          return
        }
        item.biddingStartTime = this.toDateString(startTime + (this.form.roundLength * (index) * 60 * 1000) + this.form.intervalLength * index * 60 * 1000)
        item.biddingEndTime = this.toDateString(startTime + (this.form.roundLength * (index + 1) * 60 * 1000) + this.form.intervalLength * (index) * 60 * 1000)
      })
    },
    // 轮次change
    roundLengthChange() {
      const reg = /^[1-9]\d*$/
      if (!reg.test(this.form.roundLength)) {
        this.$message({
          message: '轮次时长必须为正整数！',
          type: 'warning'
        })
        this.form.roundLength = 10
      }
      this.dataDeal()
    },
    // 间隔change
    revesionChange() {
      const reg = /^[1-9]\d*$/
      if (!reg.test(this.form.intervalLength)) {
        this.$message({
          message: '间隔时长必须为正整数！',
          type: 'warning'
        })
        this.form.intervalLength = 0
      }
      this.dataDeal()
    },
    changeVal() {
      this.$forceUpdate()
    },
    roundChange(value) {
      this.$forceUpdate()
      try {
        console.log(value)
        const roundsList = {
          keys: 1,
          biddingStartTime: '',
          biddingEndTime: '',
          hidePriceSign: 'N'
        }
        // console.log(roundsList)
        // const show = Number(this.form.roundsList && this.form.roundsList.length)
        // const distance = show - value
        // if (distance === 0) { return }
        // if (distance > 0) {
        //   console.log(value)
        //   for (let i = 0; i < distance; i++) {
        //     this.form.roundsList.splice(this.form.roundsList.length - 2 + i, 1)
        //   }
        // } else {
        //   for (let i = 0; i < distance; i++) {
        //     this.form.roundsList.splice(this.form.roundsList.length - 1 + i, 0, roundsList)
        //   }
        // }
        if (((this.form.roundsList && this.form.roundsList.length) || 0) > value) {
          this.form.roundsList.splice(this.form.roundsList.length - 2, 1)
        } else {
          this.form.roundsList.splice(this.form.roundsList.length - 1, 0, roundsList)
        }
        this.dataDeal()
      } catch (error) {
        console.log(error)
      }
    },
    dealStatus() {
      console.log('ss')
    },
    delBtn(index) {
      this.$emit('delBtn', index)
    },
    // 弹出窗
    // 分页器
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    handleSizeChange(val) {
      this.querInfo.pagesize = val
      this.search()
    },
    handleCurrentChange(val) {
      this.querInfo.pagenum = val
      this.search()
    },
    addSupper() {
      this.dialogVisible = false
      this.$emit('addSupper', this.multipleSelection)
      // this.resetSupeer()
    },
    resetSupeer() {
      this.multipleSelection = []
      this.supperShowList = []
      this.keyword = ''
    },
    sortChange(column) {
      this.currentSort = { field: column.prop, order: column.order === 'descending' ? 'desc' : 'asc' }
      this.search()
    },
    async search() {
      try {
        this.ruleSearchLoading = true
        const params = {
          field: 'phone',
          keyword: this.keys,
          officeType: 2,
          order: 'asc'
        }
        if (Object.keys(this.currentSort).length > 0) {
          params.field = this.currentSort.field
          params.order = this.currentSort.order
        }
        const info = await http({
          url: '/sysOffice/getSysOfficeByParams',
          baseURL: process.env.VUE_APP_BASE_DATA_API,
          data: {
            condition: {
              ...params,
              ...this.sort
            },
            current: this.querInfo.pagenum,
            size: this.querInfo.pagesize
          }
        })
        this.total = info.total
        this.supperShowList = info.records
      } catch (error) {
        console.log(error)
      } finally {
        this.ruleSearchLoading = false
      }
    }
    // onSuccess(...rest) {
    //   console.log(...rest)
    //   // this.data.fileList = fileList.map(({ response }) => ({ fileId: response.data.id, fileName: response.data.fileName }))
    // }
  }

}
</script>
<style lang="scss" scoped>
@import './common.scss';
.rule-contaniner{
  /deep/ {
    .el-table th > .cell {
      padding-left: 14px;
    }
  }
  /deep/ {
    .el-checkbox__input.is-disabled + span.el-checkbox__label {
      color: #333;
      cursor: not-allowed;
    }
  }
   /deep/ {
    .el-input-number__decrease, .el-input-number__increase{
      color: #fff;
      background-color: #008ee3;
      border-color: #008ee3;
      border-radius: 0;
    }
    .el-input-number__decrease.is-disabled, .el-input-number__increase.is-disabled{
      color: #C0C4CC;;
      background-color: #f5f7fa;
      border-color: #f5f7fa;
    }
    .el-input-number .el-input__inner{
      text-align: center;
    }
  }
}
.show-company-list{
  box-sizing: border-box;
  padding-left: 45px;
  .title {
    font-size: 12px;
    width: 100%;
    padding-bottom: 10px;
  }
}
.company-upload{
  &-img{
    width: 120px;
    height: 120px;
    cursor: pointer;
  }
}
.company-list{
  display: flex;
  flex-wrap: wrap;
  &-item{
    box-sizing: border-box;
    position: relative;
    width: 289px;
    height: 120px;
    padding: 10px;
    font-size: 13px;
    background-color: #fff;
    border: 1px solid rgba(225, 225, 225, 1);
    margin-right: 20px;
    margin-bottom: 10px;
    .lable {
      margin-bottom: 3px;
      height: 18px;
      line-height: 18px;
      color: #333333;
      font-weight: 500;
      font-size: 14px;
    }
    p{
      color: #757575;
      font-size: 13px;
      line-height: 24px;
      margin: 3px 0;
      width: calc(100% - 35px);
      overflow: hidden;
      text-overflow:ellipsis;
      white-space: nowrap;

    }
    .btn-remove{
      display: none;
      position: absolute;
      right: 10px;
      top: 50%;
      transform:translate(0,-50%);
    }
  }
  &-item:hover .btn-remove {
    display: inline-block !important;
  }
  &-item:hover {
    border: 1px solid rgba(0, 142, 227, 1);
  }

}
</style>
